module.exports = __webpack_public_path__ + "click-to-runwp9d372defcdefbe6a485ae4d4826986e5.png";